export default __webpack_public_path__ + "static/media/PPR_logo.d9d009ee.png";